/* esm.sh - d3-transition@3.0.1 */
export * from "/*d3-transition@3.0.1/esnext/d3-transition.mjs";
